import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from './Home'
import Explore from './Pages/Explore'

export default function AppRoutes() {
   return (
     <>
       <Router>
         <div className="container">
           <Routes>
             <Route path="/" element={<Home />} />
             <Route path="/explore" element={<Explore />} />
             {/* <Route path="*" element={<PageNotFound />} /> */}
           </Routes>
         </div>
       </Router>
     </>
   );
 }
 